$(function() {
	
	let htmlEl = document.querySelector('html');
	let headerEl = document.querySelector('.header');
	if (!headerEl) return;

	let burgerBtn = headerEl.querySelector('.js-burger-btn');
	
	burgerBtn.addEventListener('click', function () {
		headerEl.classList.toggle('header_open');
		htmlEl.classList.toggle('open-menu');
	});		

	// 

	let mobMenuEl = document.querySelector('.header__mob-menu');
	let submenuOpenBtns = mobMenuEl.querySelectorAll('.js-submenu-open');

	submenuOpenBtns.forEach(function (submenuOpenBtn) {
		
		submenuOpenBtn.addEventListener('click', function () {
			this.parentElement.classList.toggle('header__mob-menu-item-wrap_show-submenu');
			mobMenuEl.classList.toggle('header__mob-menu_show-submenu')
		});

	});


})